import { render, staticRenderFns } from "./settingEdit.vue?vue&type=template&id=12b1ab28&scoped=true"
import script from "./settingEdit.vue?vue&type=script&lang=js"
export * from "./settingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b1ab28",
  null
  
)

export default component.exports